import { useOverlayStore, OverlayNames } from '@/hooks/useOverlayManager';
import { AddEventsToReportModal } from '@/features/AddEventsToReportModal';
import { FileSourceModal, CameraSourceModal } from '@/features/NewSourceModal';
import { NewSourceStatusDrawer } from '@/features/NewSourceStatusDrawer';

export function OverlayManager() {
    const sourceUploadProps = useOverlayStore(
        (state) => state.overlays[OverlayNames.SOURCE_UPLOAD],
    );
    const addCameraProps = useOverlayStore(
        (state) => state.overlays[OverlayNames.ADD_CAMERA],
    );
    const addEventsToReportProps = useOverlayStore(
        (state) => state.overlays[OverlayNames.ADD_EVENTS_TO_REPORT],
    );

    const close = useOverlayStore((state) => state.close);

    return (
        <>
            <FileSourceModal
                isOpen={!!sourceUploadProps}
                targetFolderId={sourceUploadProps?.targetFolderId}
                onClose={() => close(OverlayNames.SOURCE_UPLOAD)}
            />
            <CameraSourceModal
                isOpen={!!addCameraProps}
                targetFolderId={addCameraProps?.targetFolderId}
                onClose={() => close(OverlayNames.ADD_CAMERA)}
            />
            {addEventsToReportProps ? (
                <AddEventsToReportModal
                    report={addEventsToReportProps.report}
                    initialDrafts={addEventsToReportProps.drafts}
                    onClose={() => close(OverlayNames.ADD_EVENTS_TO_REPORT)}
                    onAdded={() => {
                        addEventsToReportProps.onAdded?.();
                        close(OverlayNames.ADD_EVENTS_TO_REPORT);
                    }}
                />
            ) : null}
            <NewSourceStatusDrawer />
        </>
    );
}
